import { cEl } from '../../../util';
import { submitInquiry } from '../../../api/submission';
import { getSubmissionNum } from '../Test/constants';
import CompleteMassage from './CompleteMassage';

function ContactForm() {
    const contactFormContainer = cEl('form');
    contactFormContainer.classList.add('form-container');

    const submitWrapper = cEl('div');
    submitWrapper.classList.add('submit-wrapper');

    const submitButton = cEl('button');
    submitButton.classList.add('button', 'brand-button');
    submitButton.type = 'submit';
    submitButton.innerHTML = '문의 접수';

    submitWrapper.appendChild(submitButton);

    contactFormContainer.addEventListener('submit', e => {
        e.preventDefault();
        const formData = new FormData(contactFormContainer);

        const param = Object.fromEntries(formData);
        param.submissionNum = getSubmissionNum();
        param.phone = formatPhoneNumber(param.phone);

        submitInquiry(param)
            .then(() => {
                document.querySelector('.contact-container .contact-description').remove();
                document.querySelector('.contact-container .title-container').remove();

                while (contactFormContainer.hasChildNodes()) {
                    contactFormContainer.removeChild(contactFormContainer.firstChild);
                }

                contactFormContainer.append(CompleteMassage(param));
            })
            .catch(console.error);
    });

    contactFormContainer.append(
        InputGroup({
            id: 'name',
            name: 'name',
            required: true,
            label: '이름',
            inputType: 'text',
            placeholder: '성함을 입력해주세요.',
            inputAttr: { maxLength: 50 },
        }),
        InputGroup({
            id: 'email',
            name: 'email',
            required: true,
            label: '이메일 주소',
            inputType: 'email',
            placeholder: 'abcde@abcde.com',
            inputAttr: { maxLength: 255 },
        }),
        InputGroup({
            id: 'phone',
            name: 'phone',
            required: true,
            label: '휴대폰 번호',
            inputType: 'tel',
            placeholder: '01012345678',
            inputAttr: { maxLength: 11 },
            onInput: e => {
                const phoneInput = e.target;
                const phoneNumber = phoneInput.value;

                phoneInput.setCustomValidity(validPhoneNumber(phoneNumber));
            },
        }),
        InputGroup({
            id: 'affiliation',
            name: 'affiliation',
            label: '소속 기관',
            inputType: 'text',
            placeholder: '소속 기관을 입력해주세요.',
            inputAttr: { maxLength: 255 },
        }),
        InputGroup({
            id: 'message',
            name: 'message',
            required: true,
            label: '문의 내용',
            inputType: 'textarea',
            placeholder: '내용을 입력해 주세요.',
            inputAttr: { maxLength: 15000 },
        }),
        submitWrapper,
    );

    return contactFormContainer;
}

export function InputGroup({ id, name, required, label, inputType, inputAttr = {}, placeholder, onInput }) {
    const inputGroup = cEl('div');
    inputGroup.classList.add('input-group');

    const inputLabel = cEl('label');
    inputLabel.classList.add('input-label');
    inputLabel.innerHTML = label;
    inputLabel.for = id;
    const inputGroupType = inputType === 'textarea' ? 'textarea' : 'input';

    const input = cEl(inputGroupType);
    for (const attrKey in inputAttr) {
        input[attrKey] = inputAttr[attrKey];
    }

    if (inputType !== 'textarea') {
        input.type = inputType;
    }

    if (required) {
        inputLabel.classList.add('required');
        input.required = true;
    }

    input.placeholder = placeholder;
    input.id = id;
    input.name = name;
    if (typeof onInput === 'function') {
        input.addEventListener('input', e => {
            onInput(e);
        });
    }

    inputGroup.append(inputLabel, input);

    return inputGroup;
}

export function InputGroupWithErrMsg({
    id,
    name,
    required,
    label,
    inputType,
    inputAttr = {},
    placeholder,
    defaultErrorMsg,
    getErrorMsg,
    handleInput,
}) {
    const inputGroup = InputGroup({ id, name, required, label, inputType, inputAttr, placeholder });

    const errMsg = cEl('div');
    errMsg.classList.add('err-msg');
    errMsg.append(defaultErrorMsg);
    inputGroup.append(errMsg);

    inputGroup.querySelector('input').addEventListener('input', e => {
        if (typeof getErrorMsg === 'function') {
            const currErrMsg = getErrorMsg(e.target.value);
            if (currErrMsg) {
                inputGroup.classList.add('invalid');
                errMsg.innerHTML = currErrMsg;
            } else {
                inputGroup.classList.remove('invalid');
                errMsg.innerHTML = '';
            }
        }
        if (typeof handleInput === 'function') {
            handleInput(e);
        }
    });

    return inputGroup;
}

function formatPhoneNumber(number) {
    const phoneNumber = number.replace(/\D/g, '');

    // 9자리: 02-123-4567
    if (/^0\d{1}\d{3}\d{4}$/.test(phoneNumber)) {
        return phoneNumber.replace(/^(\d{2})(\d{3})(\d{4})$/, '$1-$2-$3');
    }

    // 10자리: 031-123-4567 또는 02-1234-5678
    if (/^0\d{1,2}\d{3}\d{4}$/.test(phoneNumber)) {
        if (phoneNumber.startsWith('02')) {
            return phoneNumber.replace(/^(\d{2})(\d{4})(\d{4})$/, '$1-$2-$3');
        } else {
            return phoneNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');
        }
    }

    // 11자리: 010-1234-5678
    if (/^0\d{2}\d{4}\d{4}$/.test(phoneNumber)) {
        return phoneNumber.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1-$2-$3');
    }

    return number;
}

function validPhoneNumber(number) {
    if (!/^\d+$/.test(number)) {
        return '휴대폰 번호는 숫자만 입력 가능합니다.';
    }

    // 9자리: 02-123-4567
    // 10자리: 031-123-4567 또는 02-1234-5678
    // 11자리: 010-1234-5678
    if (
        !(/^0\d{1}\d{3}\d{4}$/.test(number) || /^0\d{1,2}\d{3}\d{4}$/.test(number) || /^0\d{2}\d{4}\d{4}$/.test(number))
    ) {
        return '휴대폰 번호를 확인해 주세요.';
    }

    return '';
}

export default ContactForm;
